import { makeStyles } from 'tss-react/mui';

const useStylesFieldPassword: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldPassword: {
    width: '100%',
    minWidth: '50px !important',
    '& > div': {
      minHeight: 40,
      '& > input': {
        fontSize: 14,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 7,
        paddingBottom: 7,
      },
    },
  },
  fieldPasswordNoUnderline: {
    '& > div:before, & > div:after': {
      display: 'none',
    },
  },
  fieldPasswordOutlined: {
    '& > div > input': {
      minHeight: 0,
      backgroundColor: theme.palette.background.default,
      paddingLeft: 14,
      paddingRight: 14,
      paddingTop: 16.5,
      paddingBottom: 16.5,
    },
  },
  fieldPasswordBordered: {
    '& > div': {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
  fieldPasswordVisibilityChangeable: {
    '& > div > input': {
      width: 'calc(100% - 84px)',
    },
  },
  fieldPasswordIcon: {
    cursor: 'pointer',
  },
  fieldPasswordActionButton: {
    marginLeft: '-30px !important',
    marginTop: '8px !important',
    right: 5,
  },
  fieldPasswordActionButtonOutlined: {
    marginLeft: '-40px !important',
  },
}));

export default useStylesFieldPassword;
